/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import AddEmployee from './AddEmployee/index'
import BulkActions from './BulkActions/index'
import DeleteModal from './DeleteModal/index'
import EmployeeTable from './EmployeeTable/index'
import HorizontalDivider from 'DesignSystem/HorizontalDivider/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/Subscribers/Content"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let selectedBulkUserIdsValueData = fromData.useDataFormat({ viewPath,
context: 'selected',
path: 'bulk_user_ids',
format: fromFormat.isNotEmptyList,
})
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pl-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-3-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 marginBottom={dtSpaceXs}
 level="h4"
 text="Subscriptions"
/>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 text="Send invites to other employees to subscribe to specific stages of this Board."
 marginBottom={dtSpaceS}
/>
<fromFlow.When is={selectedBulkUserIdsValueData}>
<BulkActions
  viewPath={`${viewPath}/BulkActions`}
 data="selected.bulk_user_ids"
 format="/Data/format.js isNotEmptyList"
/>
</fromFlow.When>
</div>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
 marginBottom={dtSpaceS}
/>
<AddEmployee
  viewPath={`${viewPath}/AddEmployee`}
/>
<EmployeeTable
  viewPath={`${viewPath}/EmployeeTable`}
/>
<DeleteModal
  viewPath={`${viewPath}/DeleteModal`}
/>
</div>
{children}
</React.Fragment>)
}